import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/auth/AuthProvider';
import { homePathFor } from '@/lib/home-path';
import { startTour } from './tour-store';

/** «أعد الجولة» من أي صفحة: الجولةُ تبدأ من الصفحة الأولى، ففيها اختصاراتُه وكلُّ أهدافها */
export function useRestartTour() {
  const { roles } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return () => {
    const home = homePathFor(roles);
    if (pathname !== home) navigate(home);
    // بعد الانتقال بإطار: أهدافُ الجولة في الصفحة الأولى تُقاس وهي معروضة
    requestAnimationFrame(() => startTour('manual'));
  };
}
